import React from 'react';
import classNames from 'classnames/bind';
import * as Constants from '../../constants/product.constants';
import {
  displayValue,
  getCommaPriceFormate,
  displayValueWithSymbolAndDiscount
} from '../../utils/priceUtils';
import { displayValueWithoutSymbol, getDiscountValueWithoutPercentage } from '../../../utils/price';
import Text from '../../atoms/Text';
import Image from '../../atoms/ImageView';
import styles from './index.pcss';
import luxestyles from './luxeStyles.pcss';
import { isCatalogNameInFirebaseStore } from '../../../utils/common';
import { getFeatureVariant } from '../../organism/ABFeature/Feature';
import { getStoreName } from '../../../modules/ga/GTMdatalayer';

const cx = classNames.bind(styles);
const luxecx = classNames.bind(luxestyles);

export const ProductPrice = props => {
  const {
    productCatalog,
    storesForHidingMRP,
    isBBSDuringSale,
    isBBS,
    showPriceForEarlyAccess,
    price,
    luxe,
    luxePriceImgSrc,
    priceImgSrc,
    originalPrice,
    discountPrice,
    discountPercentage,
    isBothPriceSame,
    hasPdpAsParent,
    discountValueInINR,
    tradeDiscountValueExpFlag,
    tradeDiscountPercentageMax,
    tradeDiscountValueMin,
    emiDiscountEnable = false
  } = props;
  const hideMRP = isCatalogNameInFirebaseStore(storesForHidingMRP, productCatalog);

  const getDiscountPctOrValue = () => {
    try {
      if (!hasPdpAsParent) return discountPercentage;
      const storeName = getStoreName();
      if (storeName !== 'ajio') return discountPercentage;
      if (!tradeDiscountValueExpFlag) return discountPercentage;
      const featureVariant = getFeatureVariant('tdDiscountExperiment');
      if (featureVariant === '0') return discountPercentage;
      if (!(tradeDiscountPercentageMax && tradeDiscountValueMin)) return discountPercentage;
      if (Number.isNaN(discountValueInINR)) return discountPercentage;
      const dicountValueInPercentage = parseFloat(
        getDiscountValueWithoutPercentage(discountPercentage)
      );
      const shouldDisplayDiscountValue =
        dicountValueInPercentage <= parseFloat(tradeDiscountPercentageMax) &&
        discountValueInINR >= parseFloat(tradeDiscountValueMin);
      const discountValueWithSymbol = displayValueWithSymbolAndDiscount(String(discountValueInINR));
      return shouldDisplayDiscountValue ? discountValueWithSymbol : discountPercentage;
    } catch {
      return discountPercentage;
    }
  };

  const discountPercentageOrValue = getDiscountPctOrValue();

  return ((isBBSDuringSale && isBBS) || showPriceForEarlyAccess) && !price ? (
    <div className={cx('price-detail', 'pr-price')}>
      <div
        className={`${luxe ? luxecx('luxe-bbs-container-bg') : ''} ${cx('bbs-container')} ${
          showPriceForEarlyAccess ? cx('early-access') : ''
        }`}
      >
        <div className={luxe ? cx('luxe-bbs-logo-container') : cx('bbs-logo-container')}>
          <Image src={luxe ? luxePriceImgSrc?.image : priceImgSrc?.image} alt={luxe ? luxePriceImgSrc?.altText : priceImgSrc?.altText} />
        </div>
        <Text
          id="pdp_discount_price"
          variant={luxe ? 'T3' : 'T4'}
          color={luxe ? 'Light_Black' : 'Nero'}
          weight={luxe ? 'regular' : 'bold'}
        >
          {!originalPrice && `${Constants.SHOW_MRP_TEXT} `}
        </Text>
        <Text
          id="pdp_discount_price"
          variant={luxe ? 'T3' : 'T4'}
          color={luxe ? 'Light_Black' : 'Nero'}
          weight={luxe ? 'regular' : 'bold'}
        >
          {`${getCommaPriceFormate(discountPrice)}    `}
        </Text>
        {hideMRP && (
          <span className={luxe ? luxecx('original-price') : cx('original-price')}>
            <Text
              id="pdp_original_price"
              variant={luxe ? 'T2' : 'T3'}
              color={luxe ? 'Charcoal' : 'Dark_Grey'}
              weight="regular"
            >
              {`${originalPrice}` && `${Constants.SHOW_MRP_TEXT} `}
            </Text>
            <Text
              id="pdp_original_price"
              variant={luxe ? 'T2' : 'T3'}
              color={luxe ? 'Charcoal' : 'Dark_Grey'}
              weight="regular"
              textDecoration="strikethrough"
            >
              {`${getCommaPriceFormate(originalPrice)}`}
            </Text>
          </span>
        )}
        {hideMRP && (
          <Text
            id="pdp_discount_percent"
            variant={luxe ? 'T2' : 'T3'}
            color={luxe ? 'Light_Black' : 'Jade'}
            weight="bold"
            textTransform="is-lowercase"
          >
            {`${discountPercentageOrValue}`}
          </Text>
        )}
      </div>
    </div>
  ) : (
    <div 
      tabIndex={0}
      className={cx('price-detail')}
      aria-labelledby="pdp_discount_price-text pdp_discount_price-mrp pdp_discount_price-rs pdp_discount_price-val pdp_original_price-main pdp_discount_percent"
    >
      <span aria-hidden="true">
        <span
          className='sr-only'
          id='pdp_discount_price-text'
        >
          Current Offer Price: 
        </span>
      </span>
      <Text
        id="pdp_discount_price-mrp"
        variant={luxe ? 'T3' : 'T4'}
        color={luxe ? 'Light_Black' : 'Nero'}
        weight={luxe ? 'regular' : 'bold'}
        ariaHidden={true}
      >
        {!originalPrice && !isBothPriceSame && `${Constants.SHOW_MRP_TEXT} `}
      </Text>
      <Text
        id="pdp_discount_price-rs"
        variant={luxe ? 'T3' : emiDiscountEnable ? 'T5' : 'T4'}
        color={luxe ? 'Light_Black' : 'Nero'}
        weight={luxe ? 'regular' : 'bold'}
        ariaHidden={true}
      >
        {Constants.ruppesSymbol}
      </Text>
      <Text
        id="pdp_discount_price-val"
        variant={luxe ? 'T3' : emiDiscountEnable ? 'T5' : 'T4'}
        color={luxe ? 'Light_Black' : 'Nero'}
        weight={luxe ? 'regular' : 'bold'}
        ariaHidden={true}
      >
        {`${displayValueWithoutSymbol(getCommaPriceFormate(discountPrice))}`}
      </Text>

      {hideMRP && (
        <span 
          className={luxe ? luxecx('original-price') : cx('original-price')}
          id='pdp_original_price-main'
          aria-labelledby='pdp_original_price-text pdp_original_price-mrp pdp_original_price-rs pdp_original_price-val pdp_discount_percent'
          aria-hidden="true"
        >
          <span  aria-hidden="true">
            <span  
              className='sr-only'
              id='pdp_original_price-text'
            >
              Actual Price: 
            </span>
          </span>
          <Text
            id="pdp_original_price-mrp"
            variant={luxe ? 'T2' : 'T3'}
            color={luxe ? 'Charcoal' : 'Dark_Grey'}
            weight="regular"
            ariaHidden={true}
          >
            {`${originalPrice}` && `${Constants.SHOW_MRP_TEXT} `}
          </Text>
          <Text
            id="pdp_original_price-rs"
            variant={luxe ? 'T2' : 'T3'}
            color={luxe ? 'Charcoal' : 'Dark_Grey'}
            weight="regular"
            textDecoration="strikethrough"
            ariaHidden={true}
          >
            {`${originalPrice}` && Constants.ruppesSymbol}
          </Text>
          <Text
            id="pdp_original_price-val"
            variant={luxe ? 'T2' : 'T3'}
            color={luxe ? 'Charcoal' : 'Dark_Grey'}
            weight="regular"
            textDecoration="strikethrough"
            ariaHidden={true}
          >
            {`${displayValueWithoutSymbol(getCommaPriceFormate(originalPrice))}`}
          </Text>
        </span>
      )}
      {hideMRP && (
        <Text
          id="pdp_discount_percent"
          variant={luxe ? 'T2' : 'T3'}
          color={luxe ? 'Light_Black' : 'Jade'}
          weight="bold"
          textTransform="is-lowercase"
          ariaHidden={true}
        >
          {`${discountPercentageOrValue}`}
        </Text>
      )}
    </div>
  );
};
